import * as React from "react";
import { CLEcommProvider, EcommFacetProvider, ContactLensesStickyCTA, ProductImageGallery, useProductDetailSlots, ProductDetailFullWidth, ProductDetailStack, ProductDetailDescription, ProductDetailFeatures, ProductDetailDisclaimer, ProductDetailDrawerStack, ProductDetailSpecification, ProductDetailManufacturerDrawer, ProductDetailReviewsDrawer, ContactLensesEcommContent, mapServerToContactLensProduct, getContactLensBySlug } from "@grandvisionhq/fun-products";
import { P as ProductPageLayoutBase, a as ProductPageBase, b as defaultContactLensFacetConfig, f as fetchProductConfigBySlug, h as handleValidations } from "../../ProductPageLayoutBase.js";
import { CmsComponentSlot } from "@grandvisionhq/bloomreach";
const EcommContent = (props) => /* @__PURE__ */ React.createElement(ContactLensesEcommContent, { ...props });
const PrimaryProductInfo = (props) => /* @__PURE__ */ React.createElement(ProductDetailStack, { ...props }, /* @__PURE__ */ React.createElement(ProductDetailDescription, { className: "product-detail-stack__description" }, /* @__PURE__ */ React.createElement(ProductDetailFeatures, null)), /* @__PURE__ */ React.createElement(ProductDetailDisclaimer, { className: "product-detail-stack__disclaimer" }), /* @__PURE__ */ React.createElement(ProductDetailDrawerStack, { className: "product-detail-stack__drawer-stack" }, /* @__PURE__ */ React.createElement(ProductDetailSpecification, null), /* @__PURE__ */ React.createElement(ProductDetailManufacturerDrawer, null), /* @__PURE__ */ React.createElement(ProductDetailReviewsDrawer, null)));
const SecondaryProductInfo = () => {
  const { Slots: OpcoSlots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement(ProductDetailFullWidth, null, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/row-pdp-container" }), OpcoSlots.SecondaryProductInfoSlot && /* @__PURE__ */ React.createElement(OpcoSlots.SecondaryProductInfoSlot, null));
};
const ContactLensDetailPage = (props) => /* @__PURE__ */ React.createElement(CLEcommProvider, { ...props }, /* @__PURE__ */ React.createElement(EcommFacetProvider, null, /* @__PURE__ */ React.createElement(
  ProductPageLayoutBase,
  {
    EcommContent,
    ImageGallery: ProductImageGallery,
    PrimaryProductInfo,
    StickyCta: ContactLensesStickyCTA,
    SecondaryProductInfo
  }
)));
const Page = ({
  maxOrderableQuantity,
  facetConfigList,
  ...props
}) => /* @__PURE__ */ React.createElement(ProductPageBase, { ...props, facetConfigList: facetConfigList ?? defaultContactLensFacetConfig }, /* @__PURE__ */ React.createElement(ContactLensDetailPage, { maxOrderableQuantity }));
Page.getInitialProps = async (ctx) => {
  const productConfig = await fetchProductConfigBySlug(
    ctx,
    getContactLensBySlug,
    mapServerToContactLensProduct,
    ctx?.pageConfig?.facetConfigList ?? defaultContactLensFacetConfig
  );
  if ("failure" in productConfig) {
    return handleValidations(productConfig, `Error while initializing Contact Lens PDP`);
  }
  const { product, activeVariant, sku, slug, bloomreachPathOverride } = productConfig;
  return {
    sku,
    slug,
    product,
    activeVariant,
    bloomreachPathOverride
  };
};
export {
  Page
};
//# sourceMappingURL=contact-lens.js.map
